<dgx-search-landing-page
  [title]="'Opportunities_Mentors' | translate"
  [isLoading]="!hasError && !(data | async)"
  [hasError]="hasError"
  [results]="(data | async)?.items"
  [hideOrgSelector]="true"
  [hideFilters]="true"
  [totalNumResults]="(data | async)?.totalCount"
  [searchOrigin]="searchOrigin"
  (searchTerm)="search($event)"
>
  <ul id="results" class="grid">
    <li
      *ngFor="let item of (data | async)?.items"
      class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
      data-dgat="search-mentors-view-270"
    >
      <!-- linter error
      [location]="location"
      Can't bind to 'location' since it isn't a known property of 'dgx-user-card'.
    -->
      <dgx-user-card [user]="item" class="tile__wrapper"></dgx-user-card>
    </li>
  </ul>
</dgx-search-landing-page>
